/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramPeriodConfig } from '../../models/program-period-config';

export interface ListAdminProgramPeriodConfigs$Params {}

export function listAdminProgramPeriodConfigs(
  http: HttpClient,
  rootUrl: string,
  params?: ListAdminProgramPeriodConfigs$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<ProgramPeriodConfig>>> {
  const rb = new RequestBuilder(rootUrl, listAdminProgramPeriodConfigs.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProgramPeriodConfig>>;
    })
  );
}

listAdminProgramPeriodConfigs.PATH = '/admin/program-period-configs';
